module.exports = __webpack_public_path__ + "media/application/images/2022/digital-521cff15e3164cf5dea4cbe11f919cf6.jpg";